import React, { Fragment } from "react";
import Annualized from "./annualized";
import CalendarYrHolder from "./calendarYrHolder";

const yearly = ({
  type,
  benchmark_name,
  display_orig_portfolio,
  model_name,
  typeName,
  calendar_yearly_data,
  annuaized_yearly_data,
}) => {
  return (
    <Fragment>
      {type == "BACKTEST" ? (
        <div className="row">
          {annuaized_yearly_data && annuaized_yearly_data.length > 0 ? (
            <Fragment>
              <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                <Annualized
                  annuaized_yearly_data={annuaized_yearly_data}
                  typeName={typeName}
                  benchmark_name={benchmark_name}
                  display_orig_portfolio={display_orig_portfolio}
                  model_name={model_name}
                />
              </div>
            </Fragment>
          ) : null}
          <Fragment>
            {calendar_yearly_data && calendar_yearly_data.length ? (
              <CalendarYrHolder
                calendar_yearly_data={calendar_yearly_data}
                benchmark_name={benchmark_name}
                typeName={typeName}
                display_orig_portfolio={display_orig_portfolio}
                model_name={model_name}
              />
            ) : null}
          </Fragment>
        </div>
      ) : null}
    </Fragment>
  );
};
export default yearly;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/performance/yearlyPerformance/yearly.jsx